import {
  GET_PRODUCT_DETAIL,
  PRODUCT_DETAIL_ERROR,
  LOADING_PRODUCT_DETAIL,
  DETAIL_ACCSSORIES,
} from '../actions/types';

const initialState = {
  productDetail: {},
  loading: false,
  error: {},
};

export default (state = initialState, action) => {
  const {type, payload} = action;
  switch (type) {
    case GET_PRODUCT_DETAIL:
      return {
        ...state,
        productDetail: payload,
        loading: false,
      };
    case DETAIL_ACCSSORIES:
      return {
        ...state,
        productDetail: payload,
        loading: false,
      };

    case LOADING_PRODUCT_DETAIL:
      return {...state, loading: true};
    case PRODUCT_DETAIL_ERROR:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};
